import api from '@/api/Api'
import Result from '@/models/results/result'
import vectorUtils from '@utils/vectorUtils'

export const state = {
  results: {},
  sharedResults: {},
  resultsIndex: 1
}

export const getters = {
  results (state) {
    return state.results
  },
  sharedResults (state) {
    return state.sharedResults
  },
  resultsIndex (state) {
    return state.resultsIndex
  }
}

export const mutations = {
  RESET_DATA (state) {
    state.resultsIndex = state.resultsIndex + 1
  },
  SET_RESULT (state, newValue) {
    state.results = newValue
  },
  SET_SHARE_RESULT (state, newValue) {
    state.sharedResults = newValue
  },
  SET_LOADING (state, data) {
    state.results.data.forEach(val => {
      if (val.id === data.id) {
        val.loading = data.loading
      }
      return state.tasks
    })
  }
}

export const actions = {
  removeResultFromShareWithMe ({ commit, dispatch, state }, form) {
    return api.removeResultFromShareWithMe(form).then((response) => {
      return response
    })
  },
  copyResultFromShareWithMe ({ commit, dispatch, state }, form) {
    return api.copyResultFromShareWithMe(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  fetchSharedResult ({ commit, state }, data) {
    return api.getShareResults(data).then((response) => {
      let results = response.data.data
      results.data.map(val => {
        val.loading = false
        val.size = val.size ? val.size : 0
        if (val.meta && !val.meta.bbox && val.meta.geometry) {
          val.meta.bbox = vectorUtils.coordinatesToBBox(val.meta.geometry.features[0].geometry.coordinates)
        }
        return results
      })
      commit('SET_SHARE_RESULT', results)
      return results
    })
  },
  polygonize ({ commit, dispatch, state }, form) {
    return api.polygonize(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  reClassification ({ commit, dispatch, state }, form) {
    return api.reClassification(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  onMorphology ({ commit, dispatch, state }, form) {
    return api.morphology(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  fetchResult ({ commit, state }, id) {
    commit('RESET_DATA')
  },
  getDetailResult  ({ commit, dispatch, state }, form) {
    return api.getDetailResult(form).then((response) => {
      if (response.data.data.meta && !response.data.data.meta.bbox && response.data.data.meta.geometry) {
        response.data.data.meta.bbox = vectorUtils.coordinatesToBBox(response.data.data.meta.geometry.features[0].geometry.coordinates)
      }
      return response.data
    })
  },
  getResult ({ commit, state }, data) {
    return api.getNewResults(data).then((response) => {
      let transformData = response.data.data.data.map(val => new Result(val))
      let results = response.data.data
      results.data = transformData
      commit('SET_RESULT', results)
      return results
    })
  },
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    dispatch('fetchResult', workspaceId)
  },
  deleteResult ({ commit, dispatch, state }, form) {
    return api.deleteDetectionResult(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  renameResult ({ commit, dispatch, state }, form) {
    return api.renameDetectionResult(form).then((response) => {
      const results = response
      dispatch('fetchResult', form.workspaceId)
      return results
    })
  },
  centroidResult ({ commit, dispatch, state }, form) {
    return api.getCentroidResult(form).then((response) => {
      const results = response
      dispatch('fetchResult', form.workspaceId)
      return results
    })
  },
  downloadResult ({ commit, dispatch, state }, url) {
    return api.downloadDetectionResult(url).then((response) => {
      return response.data
    })
  },
  getHistogram ({ commit, dispatch, state }, form) {
    return api.getHistogram(form).then((response) => {
      return response.data
    })
  },
  createNewLayer ({ commit, dispatch, state }, form) {
    return api.createNewLayerResult(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  editLayer ({ commit, dispatch, state }, form) {
    return api.EditLayerResult(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  downloadToPC ({ commit, dispatch, state }, data) {
    api.downloadDetectionResult(data.url).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${data.name}.geojson`)
      document.body.appendChild(link)
      link.click()
      return response
    })
  },
  vectorization ({ commit, dispatch, state }, form) {
    return api.vectorization(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  },
  vectorizationDataset ({ commit, dispatch, state }, form) {
    return api.vectorizationDataset(form).then((response) => {
      dispatch('fetchResult', form.workspaceId)
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/result.js